import React from "react";

const TQFooter = () => {
  return React.createElement("tq-footer");
};

export default TQFooter;